import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from "./Edit.module.css";
import {
  Accordion,
  Breadcrumb,
  Col,
  Form,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import SecBTN from "../../../../UI/SecBTN";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Graybg from "../../../../UI/Graybg";
import Card from "../../../../UI/Card/Card";
import Select from "../../../../UI/Select/Select";
import Loader from "../../../../UI/loader/loader";
import userService from "../../../../app/services/user.service";
import MultiSelectDropdown from "../../../../UI/MultiSelectDropdown/MultiSelectDropdown";
import RenderText from "./RenderText/RenderText";
import { isEmpty, linkReplaceFn } from "../../../../utils/custom_funtions";
import { prepareMathHtmlForEditor } from "../../../../utils/mathmlMatrixUtils";
import MyEditor from "../../../../Components/CkEditor/CkEditor";
import Toast from "../../../../UI/Toast/Toast";
import { toast } from "react-toastify";
import Input from "../../../../UI/Input/Input";
import FullscreenModal from "../../../../UI/FullscreenModal/FullscreenModal";
import Modals from '../../../../UI/Modals/Modals'
import moment from "moment";
import DrmVideoPlayer from "../../../../Components/VideoPlayer/DrmVideoPlayer";
import { validateOptionCounts } from "./optionSaveValidation";

const MAX_OPTIONS = 4;

const NORMAL_PARAGRAPH_TYPE_IDS = [5, 17];
const MATRIX_PARAGRAPH_TYPE_IDS = [9, 10];

const Edit = () => {
  const { qid } = useParams();
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const navigate = useNavigate();
  const location = useLocation();
  const qidSearchStatus = location.status;

  const engParagraphEditorRef = useRef(null);
  const hindiParagraphEditorRef = useRef(null);
  const engMatrixParagraphEditorRef = useRef(null);
  const hindiMatrixParagraphEditorRef = useRef(null);

  const engQuestionEditorRef = useRef(null);
  const hindiQuestionEditorRef = useRef(null);
  const engQuestionDraftRef = useRef("");
  const hindiQuestionDraftRef = useRef("");
  const [questionEditorLoadId, setQuestionEditorLoadId] = useState(0);

  const engSolutionEditorRef = useRef(null);
  const hindiSolutionEditorRef = useRef(null);
  const engSolutionDraftRef = useRef("");
  const hindiSolutionDraftRef = useRef("");
  const [solutionEditorLoadId, setSolutionEditorLoadId] = useState(0);

  const originalOptionIdsRef = useRef({
    1: [], // English
    2: [], // Hindi
  });
  const optionClientKeyRef = useRef(0);

  const createOptionClientKey = (langId, optionId) => {
    if (isValidOptionId(optionId)) {
      return `${langId}-${optionId}`;
    }

    optionClientKeyRef.current += 1;
    return `new-${langId}-${optionClientKeyRef.current}`;
  };

  // Panel buttons activity
  console.log('QId', qid);
  const navBtn = [
    "Overview",
    "Question",
    "Options",
    "Hints",
    // "Supplementary",
    "Solution",
    "History",
    "Exam",
  ];
  const [navBtnActive, setNavBtnActive] = useState(navBtn[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [blockModal, setBlockModal] = useState(false);
  const [blockData, setBlockData] = useState({
    block_reason: '',
    other_reason: '',
  });

  const [topicName, setTopicName] = useState("")
  const [state, setState] = useState({
    isEditDisable: true,
    subjectList: [],
    topicList: [],
    subTopicList: [],
    toughnessList: [],
    sub_id: "",
    topic_id: "",
    topic_name: "",
    sub_topic_id: "",
    question_type_id: "",
    answer_type_id: "",
    toughness_id: "",
    applicable_for: [],
    quesTypeList: [],
    ansTypeList: [],
    isFRM: 0,
    is_JeeSheet: 0,
    is_NeetSheet: 0,
    is_PYQSheet: 0,
    is_CPS: 0,
    is_DPP: 0,
    is_FT: 0,
    is_JT: 0,
    is_NT: 0,
    eng_option: [],
    h_option: [],
    eng_option_text: "",
    hin_option_text: "",
    hint_id: "",
    hint_text: "",
    hint_text_hindi: "",
    is_required: "",
    m_p_text: "",
    m_p_text_hindi: "",
    matrix_paragraph_id: "",
    p_text: "",
    p_text_hindi: "",
    paragraph_id: "",
    q_text: "",
    q_text_hindi: "",
    sol_text: "",
    sol_text_hindi: "",
    solution_id: "",
    answer: "",
    edit_paragraph: false,
    para_edited: 0,
    matrix_para_edited: 0,
    pageNo: 0,
    paragraph_list: [],
    exam_year: [],
    exam_name: [],
    other_year: "",
    video_solution_link: "",
  });

  const isNormalParagraphType =
    NORMAL_PARAGRAPH_TYPE_IDS.includes(Number(state.question_type_id));
  const isMatrixParagraphType =
    MATRIX_PARAGRAPH_TYPE_IDS.includes(Number(state.question_type_id));

  const [quesHistory, setQuesHistory] = useState({
    answer: [],
    block: [],
    option: [],
    questio: [],
    question_type: [],
    solution: [],
    subtopic: [],
    toughness: [],
  });

  const getOverviewData = (searchQid) => {
    const targetQid = searchQid || qid;

    userService
      .getOverviewData(targetQid)
      .then((res) => {
        // Only discard previous option IDs after the new QID has successfully loaded.
        originalOptionIdsRef.current = {
          1: [],
          2: [],
        };
        if (searchQid) {
          navigate(`/editQuestion/edit/${searchQid}`)
        }
        const data = res.data;
        console.log(data);
        getTopicList(data["TblSubTopicQuestionRelations.TblSubTopic.TblTopic.TblSubject.sub_id"]);
        getSubTopicList(data["TblSubTopicQuestionRelations.TblSubTopic.TblTopic.topic_id"]);
        console.log(data["TblSubTopicQuestionRelations.TblSubTopic.TblTopic.topic_id"])
        setTopicName(data["TblSubTopic.TblTopic.topic_name"]);
        setState((prev) => {
          return {
            ...prev,
            ...data,
            sub_id: data["TblSubTopicQuestionRelations.TblSubTopic.TblTopic.TblSubject.sub_id"],
            topic_id: data["TblSubTopicQuestionRelations.TblSubTopic.TblTopic.topic_id"],
            sub_topic_id: data["TblSubTopicQuestionRelations.sub_topic_id"],
            toughness_id: data['TblToughnessCourseWises.toughness_id'],
            answer_type_id: data['answer_type_id'],
            question_type_id: data['TblQuestionTypes.type_id'],
            applicable_for: data?.applicable_for?.split(","),
            m_p_text: linkReplaceFn(data.m_p_text),
            m_p_text_hindi: linkReplaceFn(data.m_p_text_hindi),
            p_text: linkReplaceFn(data.p_text),
            p_text_hindi: linkReplaceFn(data.p_text_hindi),
            q_text: prepareMathHtmlForEditor(linkReplaceFn(data.q_text)),
            sol_text: prepareMathHtmlForEditor(linkReplaceFn(data.sol_text)),
            q_text_hindi: prepareMathHtmlForEditor(linkReplaceFn(data.q_text_hindi)),
            sol_text_hindi: prepareMathHtmlForEditor(linkReplaceFn(data.sol_text_hindi)),
            hint_text: linkReplaceFn(data.hint_text),
            hint_text_hindi: linkReplaceFn(data.hint_text_hindi),
            h_option: [],
            eng_option: [],
            exam_year: data.exam_year ? data.exam_year.split(",") : [],
            exam_name: data.exam_name ? data.exam_name.split(",") : [],
            other_year: data.other_year ?? "",
            is_JeeSheet: data.is_jee_sheet,
            is_NeetSheet: data.is_neet_sheet,
            is_PYQSheet: data.is_pyq_sheet,
            video_solution_link: data.video_cript_id || "",
          };
        });
        setQuestionEditorLoadId((prev) => prev + 1);
      })
      .then(() => {
        getHindiOptions(targetQid);
        getEngOptions(targetQid);
      })
      .catch((err) => {
        console.log(err);
        if (searchQid) {
          toast.error(`Data not found for this QID`)
        }
      });
  };

  const getEngOptions = (targetQid = qid) => {
    const body = {
      qid: targetQid,
      lang_id: 1,
    };

    userService
      .getOptions(body)
      .then((res) => {
        const options = Array.isArray(res?.data) ? res.data : [];

        const response = options.map((data) => ({
          ...data,
          client_key: createOptionClientKey(1, data.option_id),
          option: linkReplaceFn(data.option),
        }));

        originalOptionIdsRef.current[1] = response
          .map((data) => data.option_id)
          .filter(isValidOptionId);

        setState((prev) => ({
          ...prev,
          eng_option: response,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getHindiOptions = (targetQid = qid) => {
    const body = {
      qid: targetQid,
      lang_id: 2,
    };

    userService
      .getOptions(body)
      .then((res) => {
        const options = Array.isArray(res?.data) ? res.data : [];

        const response = options.map((data) => ({
          ...data,
          client_key: createOptionClientKey(2, data.option_id),
          option: linkReplaceFn(data.option),
        }));

        originalOptionIdsRef.current[2] = response
          .map((data) => data.option_id)
          .filter(isValidOptionId);

        setState((prev) => ({
          ...prev,
          h_option: response,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSubjectList = () => {
    setIsLoading(true);
    userService
      .getSubjectList()
      .then((res) => {
        setState((prev) => {
          return { ...prev, subjectList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getTopicList = (subId) => {
    setIsLoading(true);
    userService
      .getTopicListBySid(subId)
      .then((res) => {

        console.log(res.data.data)
        const topiclist = res.data.data.filter(
          (topic) => topic.status == 1 && topic.topic_sequence !== null
        );
        setState((prev) => {
          return {
            ...prev,
            topicList: topiclist,
          };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setState((prev) => {
          return {
            ...prev,
            topicList: [],
            subTopicList: [],
            topic_id: "",
            sub_topic_id: "",
          };
        });
        setIsLoading(false);
      });
  };

  const getSubTopicList = (tid, resetSelection = false) => {
    setIsLoading(true);

    userService
      .getSubTopicByTid(tid)
      .then((res) => {
        const subtopiclist = res.data.data.filter(
          (subtopic) => subtopic.status == 1 && subtopic.sub_topic_sequence !== null
        );

        setState((prev) => ({
          ...prev,
          subTopicList: subtopiclist,
          // Topic was changed - keep React state synchronized with the visually selected option
          ...(resetSelection && {
            sub_topic_id: subtopiclist.length > 0 ? subtopiclist[0].sub_topic_id : "",
          }),
        }));
      })
      .catch((err) => {
        console.error(err);

        setState((prev) => ({
          ...prev,
          subTopicList: [],
          ...(resetSelection && { sub_topic_id: "" }),
        }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getQuesTypeList = () => {
    setIsLoading(true);
    userService
      .getQuesType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, quesTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getAnsTypeList = () => {
    setIsLoading(true);
    userService
      .getAnsType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, ansTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getToughnessList = () => {
    setIsLoading(true);
    userService
      .getToughness()
      .then((res) => {
        setState((prev) => {
          return { ...prev, toughnessList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getHistoryData = (targetQid = qid) => {
    setIsLoading(true);

    const body = {
      qid: targetQid,
      start: 0,
    };

    userService
      .getQuestionHistory(body)
      .then((res) => {
        setQuesHistory(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getSubjectList();
    getToughnessList();
    getQuesTypeList();
    getAnsTypeList();
    getOverviewData();
    getHistoryData();
  }, []);

  const overviewInputHandler = (data) => {
    setState((prev) => {
      return { ...prev, ...data };
    });
  };

  const onMultiSelect = (selectedList) => {
    console.log(selectedList);
    setState((prev) => {
      return {
        ...prev,
        applicable_for: selectedList,
      };
    });
  };

  const onMultiRemove = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        applicable_for: selectedList,
      };
    });
  };
  const single_correct = state.answer_type_id == 1;
  const multi_correct = state.answer_type_id == 2;
  const integer_correct = state.answer_type_id == 3;
  const subjective = state.answer_type_id == 4;

  const optionRadioHandler = (e, i) => {
    if (e.target.checked) {
      const engArray = state.eng_option.map((data, index) => {
        if (index === i) {
          return { ...data, is_correct: 1 };
        }
        if (single_correct) {
          return { ...data, is_correct: 0 };
        }
        return data;
      });
      const hinArray = state.h_option.map((data, index) => {
        if (index === i) {
          return { ...data, is_correct: 1 };
        }
        if (single_correct) {
          return { ...data, is_correct: 0 };
        }
        return data;
      });
      setState((prev) => {
        return { ...prev, eng_option: engArray, h_option: hinArray };
      });
    } else {
      const engArray = state.eng_option.map((data, index) => {
        if (index === i) {
          return { ...data, is_correct: 0 };
        }
        return data;
      });
      const hinArray = state.h_option.map((data, index) => {
        if (index === i) {
          return { ...data, is_correct: 0 };
        }
        return data;
      });
      setState((prev) => {
        return { ...prev, eng_option: engArray, h_option: hinArray };
      });
    }
  };

  const isValidOptionId = (id) =>
    id !== "" && id !== null && id !== undefined;

  const getAvailableOptionId = (langId, currentOptions) => {
    const usedIds = new Set(
      currentOptions
        .map((option) => option.option_id)
        .filter(isValidOptionId)
        .map(String)
    );

    const availableId = originalOptionIdsRef.current[langId].find(
      (id) => !usedIds.has(String(id))
    );

    return availableId ?? "";
  };

  const createEmptyOption = (langId, currentOptions, isCorrect = 0) => {
    const optionId = getAvailableOptionId(
      langId,
      currentOptions
    );

    return {
      qid: qid,
      option_id: optionId,
      client_key: createOptionClientKey(langId, optionId),
      option: "",
      is_correct: isCorrect,
      lang_id: langId,
    };
  };

  const addNewOption = () => {
    if (
      state.eng_option.length >= MAX_OPTIONS &&
      state.h_option.length >= MAX_OPTIONS
    ) {
      toast.info(`A maximum of ${MAX_OPTIONS} options is allowed.`);
      return;
    }

    setState((prev) => {
      const engIndex = prev.eng_option.length;
      const hindiIndex = prev.h_option.length;

      return {
        ...prev,

        eng_option:
          engIndex < MAX_OPTIONS
            ? [
              ...prev.eng_option,
              createEmptyOption(
                1,
                prev.eng_option,
                prev.h_option[engIndex]?.is_correct ?? 0
              ),
            ]
            : prev.eng_option,

        h_option:
          hindiIndex < MAX_OPTIONS
            ? [
              ...prev.h_option,
              createEmptyOption(
                2,
                prev.h_option,
                prev.eng_option[hindiIndex]?.is_correct ?? 0
              ),
            ]
            : prev.h_option,
      };
    });
  };

  const removeOption = (index) => {
    setState((prev) => ({
      ...prev,
      eng_option: prev.eng_option.filter((_, i) => i !== index),
      h_option: prev.h_option.filter((_, i) => i !== index),
    }));
  };

  const saveOptions = () => {
    const validationError = validateOptionCounts({
      englishOptions: state.eng_option,
      hindiOptions: state.h_option,
      hadEnglishOptions: originalOptionIdsRef.current[1].length > 0,
      hadHindiOptions: originalOptionIdsRef.current[2].length > 0,
      maxOptions: MAX_OPTIONS,
    });

    if (validationError) {
      toast.error(validationError);
      return;
    }

    setIsLoading(true);

    const newArr = [
      ...state.eng_option,
      ...state.h_option,
    ];

    const body = {
      options: newArr.map((data) => ({
        qid: qid,
        opt_id: data.option_id ?? "",
        is_correct: data.is_correct,
        language: data.lang_id,
        opt_txt: data.option,
        answer_type: state.answer_type_id,
        inserted_by: user_id,
      })),
    };

    userService
      .createOptions(body)
      .then((res) => {
        setIsLoading(false);
        console.log(res);

        // Re-fetching options here is useful:
        // any blank IDs newly generated by backend become known IDs.
        getOverviewData();

        toast.success("Options successfully created.");
        setNavBtnActive("Overview");
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.error("Something went wrong!");
      });
  };

  const saveOptionsInput = () => {
    setIsLoading(true);
    const body = {
      options: [
        {
          qid: qid,
          opt_id: "",
          is_correct: "",
          language: "",
          opt_txt: state.answer,
          answer_type: state.answer_type_id,
          inserted_by: user_id,
        },
      ],
    };
    userService
      .createOptions(body)
      .then((res) => {
        setIsLoading(false);
        console.log(res);
        getOverviewData();
        toast.success("Answer successfully created.");
        setNavBtnActive("Overview");
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.error("Something went wrong!");
      });
  };

  const getParagraphList = (pageNo) => {
    setIsLoading(true);
    const body = {
      sub_topic: state.sub_topic_id,
      toughness: state.toughness_id,
      // qid: qid,
      qid: 1,
      start: pageNo,
      selectType: state.question_type_id,
    };
    userService
      .getParagraphs(body)
      .then((res) => {
        overviewInputHandler({ paragraph_list: res.data });
        setIsLoading(false);
        setShowModal(true);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        toast.error("Something went wrong!!");
      });
  };

  const checkBoxhandler = e => {
    if (e.target.checked) {
      overviewInputHandler({ [e.target.name]: 1 });
      return;
    }
    overviewInputHandler({ [e.target.name]: 0 });
  }

  const saveParagraph = () => {
    let updates;

    if (isNormalParagraphType) {
      updates = {
        p_text:
          engParagraphEditorRef.current?.getData?.() ?? state.p_text,
        p_text_hindi:
          hindiParagraphEditorRef.current?.getData?.() ?? state.p_text_hindi,
        para_edited: 1,
        matrix_para_edited: 0,
      };
    } else if (isMatrixParagraphType) {
      updates = {
        m_p_text:
          engMatrixParagraphEditorRef.current?.getData?.() ?? state.m_p_text,
        m_p_text_hindi:
          hindiMatrixParagraphEditorRef.current?.getData?.() ??
          state.m_p_text_hindi,
        para_edited: 0,
        matrix_para_edited: 1,
      };
    } else {
      return;
    }

    return saveOverviewData(updates).then(() => {
      setState((prev) => ({
        ...prev,
        ...updates,
        edit_paragraph: false,
      }));
    });
  };

  const saveOverviewData = (overrides = {}) => {
    const currentState = {
      ...state,
      ...overrides,
    };

    const body = {
      qid,
      sub_id: currentState.sub_id,
      topic_id: currentState.topic_id,
      topic_name: currentState.topic_name,
      sub_topic_id: currentState.sub_topic_id,
      toughness_id: currentState.toughness_id,
      Qtype_id: currentState.question_type_id,
      answer_type_id: currentState.answer_type_id,

      jee_sheet: currentState.is_JeeSheet,
      neet_sheet: currentState.is_NeetSheet,
      pyq_sheet: currentState.is_PYQSheet,
      frm: currentState.isFRM,
      dpp: currentState.is_DPP,
      cps: currentState.is_CPS,
      jt: currentState.is_JT,
      nt: currentState.is_NT,
      ft: currentState.is_FT,

      paragraph_id: currentState.paragraph_id,
      p_text: currentState.p_text,
      p_text_hindi: currentState.p_text_hindi,

      matrix_paragraph: currentState.matrix_paragraph_id,
      m_p_text: currentState.m_p_text,
      m_p_text_hindi: currentState.m_p_text_hindi,

      para_edited: currentState.para_edited,
      matrix_para_edited: currentState.matrix_para_edited,

      Applicable: currentState.applicable_for.join(","),
      inserted_by: user_id,
    };

    return userService
      .createOverview(body)
      .then((res) => {
        console.log(res);
        toast.success("Question Updated Successfully.");
        return res;
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!");
        throw err;
      });
  };

  const blockQuestion = (lvl) => {
    const body = {
      qid: qid,
      blockid: lvl === 0 ? lvl : blockData.block_reason,
      other_reason: blockData.other_reason,
      updated_by: user_id,
    };
    userService.blockQuestion(body)
      .then(res => {
        console.log(res)
        setBlockModal(false)
        setBlockData({
          block_reason: '',
          other_reason: '',
        })
        toast.success(`Question ${lvl === 0 ? "Unblocked" : "Blocked"} Successfully.`);
        getOverviewData()
      })
      .catch(err => {
        console.log(err);
        toast.error('Something went wrong!')
      })
  }

  const handleTranslate = () => {
    setIsLoading(true);
    const body = {
      qid: qid,
      user_id: user_id
    };
    userService.TranslateQue(body)
      .then(res => {
        console.log(res);
        toast.success("Question Translated Successfully.");
        getOverviewData();
      })
      .catch(err => {
        console.log(err);
        toast.error("Something went wrong while translating the question!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSolutionTranslate = () => {
    setIsLoading(true);
    const body = {
      qid: qid,
      user_id: user_id
    };
    userService.TranslateSolution(body)
      .then(res => {
        console.log(res);
        toast.success("Solution Translated Successfully.");
        getOverviewData();
      })
      .catch(err => {
        console.log(err);
        toast.error("Something went wrong while translating the solution!");
      })
      .finally(() => {
        setIsLoading(false)
      });
  };

  const handleGenerateSolution = () => {
    setIsLoading(true);
    const body = {
      qid: qid,
      ai_model_type: "o4-mini"
    };
    userService.GenerateSolution(body)
      .then(res => {
        console.log(">>>>>", res);

        if (res.data?.success === 1) {
          toast.success(res.data.message || "Solution generated successfully.");
          getOverviewData();
        } else {
          toast.error(res.data?.message || "Something went wrong while generating the solution!");
        }
        getOverviewData();
      })
      .catch(err => {
        console.log(err);
        toast.error("Something went wrong while generating the solution!");
      })
      .finally(() => {
        setIsLoading(false)
      });
  };


  const renderOverview = () => {
    return (
      <>
        <Card className={classes.card}>
          <button
            className={`border border-ligh rounded-circle ${classes.edit}`}
            onClick={() => {
              if (state.isEditDisable) {
                overviewInputHandler({ isEditDisable: false });
              } else {
                overviewInputHandler({ isEditDisable: true });
              }
            }}
          >
            <i className="fa-solid fa-pen p-2" style={{ fontSize: "0.7rem" }}></i>
          </button>
          <Row>
            {(!isEmpty(state.exam_name) || !isEmpty(state.exam_year)) && (
              <Col lg={6} sm={12} className="my-1">
                <p className="ps-2">
                  Exam Name & Year :{" "}
                  <b>
                    {state.exam_name.toString()} {!isEmpty(state.exam_year) && `- ${state.exam_year.toString()}`}
                  </b>
                </p>
              </Col>
            )}
            {!state.block_lvl == 0 && (
              <Col lg={6} sm={12} className="my-1">
                <p className="ps-2">
                  Block Reason : <b>{state.block_name}</b>
                </p>
              </Col>
            )}
            <Col lg={6} sm={12} className="my-1"></Col>
          </Row>
          <Row>
            <Col lg={6} sm={12} className="my-1">
              <Select
                disabled={state.isEditDisable}
                value={state.sub_id}
                onChange={(e) => {
                  overviewInputHandler({
                    sub_id: e.target.value,
                    applicable_for: [],
                    subTopicList: [],
                    topic_id: "",
                    topic_name: state.topic_name,
                    sub_topic_id: "",
                  });
                  getTopicList(e.target.value);
                }}
              >
                <option value="" disabled>
                  Select Subject
                </option>
                {state.subjectList.map((subject) => {
                  return (
                    <option
                      key={subject.sub_id + subject.sub_name}
                      value={subject.sub_id}
                    >
                      {subject.sub_name}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={6} sm={12} className="my-1">
              <Select
                disabled={state.isEditDisable}
                value={state.topic_id}
                onChange={(e) => {
                  const topicId = e.target.value;
                  overviewInputHandler({ topic_id: topicId, sub_topic_id: "", });
                  getSubTopicList(topicId, true);
                }}
              >
                <option value="" disabled>
                  Select Topic
                </option>
                {state.topicList.map((topic) => {
                  return (
                    <option
                      key={topic.topic_id + topic.topic_name}
                      value={topic.topic_id}
                    >
                      {topic.topic_name}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={6} sm={12} className="my-1">
              <Select
                disabled={state.isEditDisable}
                value={state.sub_topic_id}
                onChange={(e) => {
                  overviewInputHandler({ sub_topic_id: e.target.value });
                }}
              >
                <option value="" disabled>
                  Select Sub-Topic
                </option>
                {state.subTopicList.map((subtopic) => {
                  return (
                    <option
                      key={subtopic.sub_topic_id + subtopic.Sub_topic_name}
                      value={subtopic.sub_topic_id}
                    >
                      {subtopic.Sub_topic_name}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={6} sm={12} className="my-1">
              <Select
                disabled={state.isEditDisable}
                value={state.question_type_id}
                onChange={(e) => {
                  overviewInputHandler({
                    question_type_id: e.target.value,
                    edit_paragraph: false,
                  });
                }}
              >
                <option value="" disabled>
                  Question type
                </option>
                {state.quesTypeList.map((quesType) => {
                  return (
                    <option
                      key={quesType.type_id + quesType.type}
                      value={quesType.type_id}
                    >
                      {quesType.type}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={4} sm={12} className="my-1">
              <Select
                disabled={state.isEditDisable}
                value={state.answer_type_id}
                onChange={(e) => {
                  overviewInputHandler({ answer_type_id: e.target.value });
                }}
              >
                <option value="" disabled>
                  Answer type
                </option>
                {state.ansTypeList.map((ansType) => {
                  return (
                    <option
                      key={ansType.answer_id + ansType.answer_type}
                      value={ansType.answer_id}
                    >
                      {ansType.answer_type}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={4} sm={12} className="my-1">
              <Select
                disabled={state.isEditDisable}
                value={state.toughness_id}
                onChange={(e) => {
                  overviewInputHandler({ toughness_id: e.target.value });
                }}
              >
                <option value="" disabled>
                  Select Toughness
                </option>
                {state.toughnessList.map(({ toughness_id, toughness }) => {
                  return (
                    <option key={toughness_id + toughness} value={toughness_id}>
                      {toughness}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={4} sm={12} className="my-1">
              {/* <Select>
                <option selected disabled>
                  Applicable for
                </option>
              </Select> */}
              <MultiSelectDropdown
                isObject={false}
                disable={state.isEditDisable}
                className={classes.overviewApplicableFor}
                options={
                  state.sub_id == 3
                    ? ["JEE Advanced", "JEE-Main"]
                    : state.sub_id == 4
                      ? ["NEET"]
                      : [
                        "JEE Advanced",
                        "JEE-Main",
                        "MHT-CET",
                        "NEET",
                        "PRMO",
                        "NTSE",
                        "IJSO",
                        "Foundation Olympiads",
                      ]
                }
                selectedValues={state.applicable_for}
                onSelect={onMultiSelect}
                onRemove={onMultiRemove}
                placeholder="Applicable For"
              />
            </Col>
          </Row>
          {/* sheet: state.isSheet,
      frm: state.isFRM,
      dpp: state.is_DPP,
      cps: state.is_CPS,
      jt: state.is_JT,
      nt: state.is_NT,
      ft: state.is_FT, */}
          <div key={`inline-checkbox`} className={`mb-2 ${classes.overviewCheckboxes}`}>
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from JEE Sheet?"
              name="is_JeeSheet"
              type="checkbox"
              checked={state.is_JeeSheet == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from NEET Sheet?"
              name="is_NeetSheet"
              type="checkbox"
              checked={state.is_NeetSheet == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from PYQ Sheet?"
              name="is_PYQSheet"
              type="checkbox"
              checked={state.is_PYQSheet == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from FRM?"
              name="isFRM"
              type="checkbox"
              checked={state.isFRM == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from DPP?"
              name="is_DPP"
              type="checkbox"
              checked={state.is_DPP == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from CPS?"
              name="is_CPS"
              type="checkbox"
              checked={state.is_CPS == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from JT?"
              name="is_JT"
              type="checkbox"
              checked={state.is_JT == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from NT?"
              name="is_NT"
              type="checkbox"
              checked={state.is_NT == 1 ? true : false}
              onChange={checkBoxhandler}
            />
            <Form.Check
              disabled={state.isEditDisable}
              inline
              label="from FT?"
              name="is_FT"
              type="checkbox"
              checked={state.is_FT == 1 ? true : false}
              onChange={checkBoxhandler}
            />
          </div>
          {!state.isEditDisable && (
            <div className="text-center">
              <SecBTN className="sec-btn1" onClick={() => saveOverviewData()}>Save Changes</SecBTN>
            </div>
          )}
        </Card>
        {/*  */}
        {isNormalParagraphType && (
          <>
            <div className="d-flex gap-2">
              <SecBTN
                className="sec-btn1"
                onClick={() => getParagraphList(state.pageNo)}
              >
                Already Exist Paragraph
              </SecBTN>
              <SecBTN
                className="sec-btn1"
                onClick={() => {
                  setState((prev) => {
                    return { ...prev, edit_paragraph: !prev.edit_paragraph };
                  });
                }}
              >
                Edit
              </SecBTN>
            </div>
            {state.edit_paragraph ? (
              <>
                <Row className="mt-3 mb-2">
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      enablePixelImageSize
                      ref={engParagraphEditorRef}
                      editorKey={`paragraph-eng-${qid}-${state.paragraph_id ?? "new"}`}
                      data={state.p_text}
                    />
                  </Col>
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      enablePixelImageSize
                      ref={hindiParagraphEditorRef}
                      editorKey={`paragraph-hin-${qid}-${state.paragraph_id ?? "new"}`}
                      data={state.p_text_hindi}
                    />
                  </Col>
                </Row>
                <div className="text-center mb-3">
                  <SecBTN
                    className="sec-btn1"
                    onClick={saveParagraph}
                  >
                    Save Paragraph
                  </SecBTN>
                </div>
              </>
            ) : (
              <>

                <RenderText
                  engTitle="Paragraph"
                  engText={state.p_text}
                  hindiTitle="अनुछेद"
                  hindiText={state.p_text_hindi}
                  parentid={state.parent_qid}
                />
              </>
            )}
          </>
        )}
        {isMatrixParagraphType && (
          <>
            <div className="d-flex gap-2">
              <SecBTN
                className="sec-btn1"
                onClick={() => getParagraphList(state.pageNo)}
              >
                Already Exist Paragraph
              </SecBTN>
              <SecBTN
                className="sec-btn1"
                onClick={() => {
                  setState((prev) => {
                    return { ...prev, edit_paragraph: !prev.edit_paragraph };
                  });
                }}
              >
                Edit
              </SecBTN>
            </div>
            {state.edit_paragraph ? (
              <>
                <Row className="mt-3 mb-2">
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      enablePixelImageSize
                      ref={engMatrixParagraphEditorRef}
                      editorKey={`matrix-paragraph-eng-${qid}-${state.matrix_paragraph_id ?? "new"}`}
                      data={state.m_p_text}
                    />
                  </Col>
                  <Col lg={6} md={12} sm={12}>
                    <MyEditor
                      enablePixelImageSize
                      ref={hindiMatrixParagraphEditorRef}
                      editorKey={`matrix-paragraph-hin-${qid}-${state.matrix_paragraph_id ?? "new"}`}
                      data={state.m_p_text_hindi}
                    />
                  </Col>
                </Row>
                <div className="text-center mb-3">
                  <SecBTN
                    className="sec-btn1"
                    onClick={saveParagraph}
                  >
                    Save Paragraph
                  </SecBTN>
                </div>
              </>
            ) : (
              <>
                {/* <h6>Parent QID:</h6> */}
                <RenderText
                  engTitle="Paragraph"
                  engText={state.m_p_text}
                  hindiTitle="अनुछेद"
                  hindiText={state.m_p_text_hindi}
                  parentid={state.parent_qid}
                />
              </>
            )}
          </>
        )}
        {/*  */}


        <RenderText
          engTitle="Question"
          engText={state.q_text}
          hindiTitle="प्रश्न"
          hindiText={state.q_text_hindi}
          engOption={state.eng_option}
          hindiOption={state.h_option}
        />
        <p className="my-2">Answer : {state.answer}</p>
        <RenderText
          engTitle="Solution"
          engText={state.sol_text}
          hindiTitle="हल"
          hindiText={state.sol_text_hindi}
        />

        {/* Video Solution Section */}
        {state.video_solution_link && (
          <Card className="mt-3" style={{ width: "50%" }}>
            <h6 className="mb-3">Video Solution</h6>
            <DrmVideoPlayer videoId={state.video_solution_link} />
          </Card>
        )}
      </>
    );
  };

  const Question = () => {
    const saveQuestion = () => {
      setIsLoading(true);
      const q_text =
        engQuestionEditorRef.current?.getData?.() ?? state.q_text;
      const q_text_hindi =
        hindiQuestionEditorRef.current?.getData?.() ?? state.q_text_hindi;
      const body = {
        qid: qid,
        q_text: q_text,
        q_text_hindi: q_text_hindi,
        inserted_by: user_id,
      };
      userService
        .createQuesText(body)
        .then((res) => {
          console.log(res);
          overviewInputHandler({
            q_text: prepareMathHtmlForEditor(body.q_text),
            q_text_hindi: prepareMathHtmlForEditor(body.q_text_hindi),
          });
          setQuestionEditorLoadId((prev) => prev + 1);
          toast.success("Question updated successfully.");
          setIsLoading(false);
          setNavBtnActive("Overview");
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
          toast.error("Something went wrong!!");
        });
    };
    return (
      <>
        <Row>
          <Col sm={12} md={6} lg={6} className="my-1">
            <MyEditor
              enablePixelImageSize
              ref={engQuestionEditorRef}
              editorKey={`eng-${qid}-${questionEditorLoadId}`}
              data={state.q_text}
              handleChange={(data) => {
                engQuestionDraftRef.current = data;
              }}
            />
          </Col>
          <Col sm={12} md={6} lg={6} className="my-1">
            <MyEditor
              enablePixelImageSize
              ref={hindiQuestionEditorRef}
              editorKey={`hindi-${qid}-${questionEditorLoadId}`}
              data={state.q_text_hindi}
              handleChange={(data) => {
                hindiQuestionDraftRef.current = data;
              }}
            />
          </Col>
        </Row>
        <div className="text-center mt-3">
          <SecBTN className="sec-btn1" onClick={saveQuestion}>
            Save Questions
          </SecBTN>
        </div>
      </>
    );
  };

  const Hints = () => {
    // Add state for multiple hints
    const [hints, setHints] = useState([
      {
        id: 1,
        hintEnglish: state.hint_text || "",
        hintHindi: state.hint_text_hindi || ""
      }
    ]);

    // Function to add a new hint row
    const addHintRow = () => {
      setHints([
        ...hints,
        {
          id: hints.length + 1,
          hintEnglish: "",
          hintHindi: ""
        }
      ]);
    };

    // Function to remove a hint row
    const removeHintRow = (indexToRemove) => {
      // Don't allow removing if only one hint remains
      if (hints.length <= 1) {
        return;
      }

      setHints(hints.filter((_, index) => index !== indexToRemove));
    };

    // Updated save function to handle multiple hints
    const saveHints = () => {
      // Prepare data for API
      const hintData = hints.flatMap((hint, index) => [
        {
          qid: qid,
          hint_txt: hint.hintEnglish,
          hint_id: state.hint_id ? state.hint_id : null,
          language: 1,
          inserted_by: user_id,
        },
        {
          qid: qid,
          hint_txt: hint.hintHindi,
          hint_id: state.hint_id ? state.hint_id : null,
          language: 2,
          inserted_by: user_id,
        },
      ]);

      const body = {
        hint: hintData,
      };

      userService
        .createHints(body)
        .then((res) => {
          console.log(res);
          toast.success("Hints updated successfully");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong!!");
        });
    };

    // Function to update a specific hint
    const updateHint = (index, field, value) => {
      const updatedHints = [...hints];
      updatedHints[index][field] = value;
      setHints(updatedHints);

      // Also update the main state for the first hint to maintain compatibility
      if (index === 0) {
        setState(prev => ({
          ...prev,
          hint_text: field === 'hintEnglish' ? value : prev.hint_text,
          hint_text_hindi: field === 'hintHindi' ? value : prev.hint_text_hindi
        }));
      }
    };

    return (
      <>
        {hints.map((hint, index) => (
          <div key={hint.id} className="position-relative mb-3">
            {hints.length > 1 && (
              <span
                className={classes.cross}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '0',
                  cursor: 'pointer',
                  zIndex: 10
                }}
                onClick={() => removeHintRow(index)}
              >
                x
              </span>
            )}

            <Row>
              <Col sm={12} md={6} lg={6} className="my-1">
                <h6>Hint {index + 1} (English)</h6>
                <MyEditor
                  enablePixelImageSize
                  data={hint.hintEnglish}
                  handleChange={(data) => updateHint(index, 'hintEnglish', data)}
                />
              </Col>
              <Col sm={12} md={6} lg={6} className="my-1">
                <h6>Hint {index + 1} (Hindi)</h6>
                <MyEditor
                  enablePixelImageSize
                  data={hint.hintHindi}
                  handleChange={(data) => updateHint(index, 'hintHindi', data)}
                />
              </Col>
            </Row>
          </div>
        ))}

        <div className="d-flex mt-2">
          <SecBTN className="sec-btn me-2" onClick={addHintRow}>
            Add Hints
          </SecBTN>
          <SecBTN className="sec-btn1" onClick={saveHints}>
            Save Hints
          </SecBTN>
        </div>
      </>
    );
  };

  const Solution = () => {
    const saveSolution = () => {
      const engSolution =
        engSolutionEditorRef.current?.getData?.() ??
        engSolutionDraftRef.current ??
        state.sol_text;

      const hinSolution =
        hindiSolutionEditorRef.current?.getData?.() ??
        hindiSolutionDraftRef.current ??
        state.sol_text_hindi;

      const engSolutionBody = {
        qid: qid,
        sol_text: engSolution,
        language: 1,
        inserted_by: user_id,
      };

      const hinSolutionBody = {
        qid: qid,
        sol_text: hinSolution,
        language: 2,
        inserted_by: user_id,
      };

      Promise.all([
        userService.createSolution(engSolutionBody),
        userService.createSolution(hinSolutionBody),
      ])
        .then((res) => {
          console.log(res);

          setState((prev) => ({
            ...prev,
            sol_text: prepareMathHtmlForEditor(engSolution),
            sol_text_hindi: prepareMathHtmlForEditor(hinSolution),
          }));

          engSolutionDraftRef.current = engSolution;
          hindiSolutionDraftRef.current = hinSolution;

          // Force CKEditor to reload with the saved content.
          setSolutionEditorLoadId((prev) => prev + 1);

          toast.success("Solution updated successfully.");
          setNavBtnActive("Overview");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong!!");
        });
    };

    return (
      <>
        <Row>
          <Col lg={6} md={12} sm={12} className="mb-3">
            <p>English :</p>

            <MyEditor
              enablePixelImageSize
              key={`eng-solution-${qid}-${solutionEditorLoadId}`}
              ref={engSolutionEditorRef}
              data={state.sol_text}
              handleChange={(data) => {
                engSolutionDraftRef.current = data;
              }}
            />
          </Col>

          <Col lg={6} md={12} sm={12} className="mb-3">
            <p>Hindi :</p>

            <MyEditor
              enablePixelImageSize
              key={`hin-solution-${qid}-${solutionEditorLoadId}`}
              ref={hindiSolutionEditorRef}
              data={state.sol_text_hindi}
              handleChange={(data) => {
                hindiSolutionDraftRef.current = data;
              }}
            />
          </Col>
        </Row>

        <SecBTN className="sec-btn1" onClick={saveSolution}>
          Save Solution
        </SecBTN>
      </>
    );
  };

  const History = () => {
    console.log(quesHistory);
    return (
      <Accordion defaultActiveKey={["0"]} alwaysOpen>
        {!isEmpty(quesHistory.questio) ? (
          <Accordion.Item eventKey="0">
            <Accordion.Header>Question</Accordion.Header>
            <Accordion.Body>
              <Tabs
                defaultActiveKey="english"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="english" title="English">
                  <div className="container-fluid">
                    {quesHistory.questio.map((item, i) => {
                      return (
                        <>
                          {!isEmpty(item.q_text) ? (
                            <div
                              className={`row align-items-center ${classes.history}`}
                              key={item.id}
                            >
                              <div className="col-lg-4">
                                <p>
                                  {moment(item.updated_on).format(
                                    "MM/DD/YYYY h:mm:ss"
                                  )}
                                </p>
                                <p className={classes.updatedby}>
                                  {item.audit_comment} BY: {item.name}
                                </p>
                              </div>
                              <div className="col-lg-8">
                                <div>
                                  {i === 0 ? (
                                    <b>Blank</b>
                                  ) : (
                                    <div
                                      style={{ color: "red" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(
                                          quesHistory.questio[i - 1].q_text
                                        ),
                                      }}
                                    />
                                  )}
                                </div>
                                <p>
                                  <small>To</small>
                                </p>
                                {i === quesHistory.questio.length ? (
                                  isEmpty(item.q_text) ? (
                                    <b>Blank</b>
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.q_text),
                                      }}
                                    />
                                  )
                                ) : (
                                  <div
                                    style={{ color: "#3c763d" }}
                                    dangerouslySetInnerHTML={{
                                      __html: linkReplaceFn(item.q_text),
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            "Data not found"
                          )}
                        </>
                      );
                    })}
                  </div>
                </Tab>
                <Tab eventKey="hindi" title="Hindi">
                  <div className="container-fluid">
                    {quesHistory.questio.map((item, i) => {
                      return (
                        <>
                          {!isEmpty(item.q_text_hindi) ? (
                            <div
                              className={`row align-items-center ${classes.history}`}
                              key={item.id}
                            >
                              <div className="col-lg-4">
                                <p>
                                  {moment(item.updated_on).format(
                                    "MM/DD/YYYY h:mm:ss"
                                  )}
                                </p>
                                <p className={classes.updatedby}>
                                  {item.audit_comment} BY: {item.name}
                                </p>
                              </div>
                              <div className="col-lg-8">
                                <div>
                                  {i === 0 ? (
                                    <b>Blank</b>
                                  ) : (
                                    <div
                                      style={{ color: "red" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(
                                          quesHistory.questio[i - 1].q_text_hindi
                                        ),
                                      }}
                                    />
                                  )}
                                </div>
                                <p>
                                  <small>To</small>
                                </p>
                                {i === quesHistory.questio.length ? (
                                  isEmpty(item.q_text_hindi) ? (
                                    <b>Blank</b>
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.q_text_hindi),
                                      }}
                                    />
                                  )
                                ) : (
                                  <div
                                    style={{ color: "#3c763d" }}
                                    dangerouslySetInnerHTML={{
                                      __html: linkReplaceFn(item.q_text_hindi),
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            "Data not found"
                          )}
                        </>
                      );
                    })}
                  </div>
                </Tab>
              </Tabs>
            </Accordion.Body>
          </Accordion.Item>
        ) : (
          <Accordion.Item eventKey="0">
            <Accordion.Header>Question</Accordion.Header>
            <Accordion.Body>
              <Tabs
                defaultActiveKey="english"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="english" title="English">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 text-center py-3">
                        <p>No data Available</p>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="hindi" title="Hindi">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 text-center py-3">
                        <p>No data Available</p>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {!isEmpty(quesHistory.option) && (
          <Accordion.Item eventKey="1">
            <Accordion.Header>Option</Accordion.Header>
            <Accordion.Body>
              <Tabs
                defaultActiveKey="english"
                id="uncontrolled-tab-option"
                className="mb-3"
              >
                <Tab eventKey="english" title="English">
                  <div className="container-fluid">
                    {isEmpty(
                      quesHistory.option.filter((data) => data.lang_id === 1)
                    )
                      ? "No data found."
                      : quesHistory.option
                        .filter((data) => data.lang_id === 1)
                        .map((item, i) => {
                          return (
                            <>
                              {!isEmpty(item.option) ? (
                                <div
                                  className={`row align-items-center  ${classes.history}`}
                                  key={item.option_id}
                                >
                                  <div className="col-lg-4">
                                    <p>
                                      {moment(item.updated_on).format(
                                        "MM/DD/YYYY h:mm:ss"
                                      )}
                                    </p>
                                    <p className={classes.updatedby}>
                                      {item.audit_comment} BY: {item.name}
                                    </p>
                                  </div>
                                  <div className="col-lg-8">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.option),
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                "Data not found"
                              )}
                            </>
                          );
                        })}
                  </div>
                </Tab>
                <Tab eventKey="hindi" title="Hindi">
                  <div className="container-fluid">
                    {isEmpty(
                      quesHistory.option.filter((data) => data.lang_id === 2)
                    )
                      ? "No data found."
                      : quesHistory.option
                        .filter((data) => data.lang_id === 2)
                        .map((item, i) => {
                          return (
                            <>
                              {!isEmpty(item.option) ? (
                                <div
                                  className={`row align-items-center  ${classes.history}`}
                                  key={item.option_id}
                                >
                                  <div className="col-lg-4">
                                    <p>
                                      {moment(item.updated_on).format(
                                        "MM/DD/YYYY h:mm:ss"
                                      )}
                                    </p>
                                    <p className={classes.updatedby}>
                                      {item.audit_comment} BY: {item.name}
                                    </p>
                                  </div>
                                  <div className="col-lg-8">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.option),
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                "Data not found"
                              )}
                            </>
                          );
                        })}
                  </div>
                </Tab>
              </Tabs>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {!isEmpty(quesHistory.solution) && (
          <Accordion.Item eventKey="2">
            <Accordion.Header>Solution</Accordion.Header>
            <Accordion.Body>
              <Tabs
                defaultActiveKey="english"
                id="uncontrolled-tab-solution"
                className="mb-3"
              >
                <Tab eventKey="english" title="English">
                  <div className="container-fluid">
                    {quesHistory.solution
                      .filter((data) => data.lang_id == 1)
                      .map((item, i) => {
                        return (
                          <>
                            {!isEmpty(item.solution) ? (
                              <div
                                className={`row align-items-center  ${classes.history}`}
                                key={item.id}
                              >
                                <div className="col-lg-4">
                                  <p>
                                    {moment(item.updated_on).format(
                                      "MM/DD/YYYY h:mm:ss"
                                    )}
                                  </p>
                                  <p className={classes.updatedby}>
                                    {item.audit_comment} BY: {item.name}
                                  </p>
                                </div>
                                <div className="col-lg-8">
                                  <div>
                                    {i === 0 ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "red" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(
                                            quesHistory.solution[i - 1].solution
                                          ),
                                        }}
                                      />
                                    )}
                                  </div>
                                  <p>
                                    <small>To</small>
                                  </p>
                                  {i === quesHistory.solution.length ? (
                                    isEmpty(item.solution) ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "#3c763d" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(item.solution),
                                        }}
                                      />
                                    )
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.solution),
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ) : (
                              "Data not found"
                            )}
                          </>
                        );
                      })}
                  </div>
                </Tab>
                <Tab eventKey="hindi" title="Hindi">
                  <div className="container-fluid">
                    {quesHistory.solution
                      .filter((data) => data.lang_id == 2)
                      .map((item, i) => {
                        return (
                          <>
                            {!isEmpty(item.solution) ? (
                              <div
                                className={`row align-items-center  ${classes.history}`}
                                key={item.id}
                              >
                                <div className="col-lg-4">
                                  <p>
                                    {moment(item.updated_on).format(
                                      "MM/DD/YYYY h:mm:ss"
                                    )}
                                  </p>
                                  <p className={classes.updatedby}>
                                    {item.audit_comment} BY: {item.name}
                                  </p>
                                </div>
                                <div className="col-lg-8">
                                  <div>
                                    {i === 0 ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "red" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(
                                            quesHistory.solution[i - 1].solution
                                          ),
                                        }}
                                      />
                                    )}
                                  </div>
                                  <p>
                                    <small>To</small>
                                  </p>
                                  {i === quesHistory.solution.length ? (
                                    isEmpty(item.solution) ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "#3c763d" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(item.solution),
                                        }}
                                      />
                                    )
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.solution),
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ) : (
                              "Data not found"
                            )}
                          </>
                        );
                      })}
                  </div>
                </Tab>
              </Tabs>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {!isEmpty(quesHistory.answer) && (
          <Accordion.Item eventKey="3">
            <Accordion.Header>Answer</Accordion.Header>
            <Accordion.Body>
              <div className="container-fluid">
                {quesHistory.answer.map((item, i) => {
                  return (
                    <>
                      {!isEmpty(item.answer) ? (
                        <div
                          className={`row align-items-center  ${classes.history}`}
                          key={item.id}
                        >
                          <div className="col-lg-4">
                            <p>
                              {moment(item.updated_on).format(
                                "MM/DD/YYYY h:mm:ss"
                              )}
                            </p>
                            <p className={classes.updatedby}>
                              {item.audit_comment} BY: {item.name}
                            </p>
                          </div>
                          <div className="col-lg-8">
                            <div>
                              {i === 0 ? (
                                <b>Blank</b>
                              ) : (
                                <div
                                  style={{ color: "red" }}
                                  dangerouslySetInnerHTML={{
                                    __html: linkReplaceFn(
                                      quesHistory.answer[i - 1].answer
                                    ),
                                  }}
                                />
                              )}
                            </div>
                            <p>
                              <small>To</small>
                            </p>
                            {i === quesHistory.answer.length ? (
                              isEmpty(item.answer) ? (
                                <b>Blank</b>
                              ) : (
                                <div
                                  style={{ color: "#3c763d" }}
                                  dangerouslySetInnerHTML={{
                                    __html: linkReplaceFn(item.answer),
                                  }}
                                />
                              )
                            ) : (
                              <div
                                style={{ color: "#3c763d" }}
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(item.answer),
                                }}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        "Data not found"
                      )}
                    </>
                  );
                })}
              </div>
              {/* <Tab eventKey="hindi" title="Hindi">
                <div className="container-fluid">
                    {quesHistory.questio.map((item,i) => {
                      return (
                        <>
                        {!isEmpty(item.q_text_hindi) ? <div
                          className={`row align-items-center  ${classes.history}`}
                          key={item.id}
                        >
                          <div className="col-lg-4">
                            <p>
                              {moment(item.updated_on).format(
                                "MM/DD/YYYY h:mm:ss"
                              )}
                            </p>
                            <p className={classes.updatedby}>
                              {item.audit_comment} BY: {item.name}
                            </p>
                          </div>
                          <div className="col-lg-8">
                            <div>
                              {i === 0 ? (
                                <b>Blank</b>
                              ) : (
                                <div
                                  style={{color:"red"}}    
                                  dangerouslySetInnerHTML={{
                                    __html: linkReplaceFn(
                                      quesHistory.questio[i - 1].q_text_hindi
                                    ),
                                  }}
                                />
                              )}
                            </div>
                            <p><small>To</small></p>
                            {i === quesHistory.questio.length ? (
                                  isEmpty(item.q_text_hindi) ? (
                                    <b>Blank</b>
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.q_text_hindi),
                                      }}
                                    />
                                  )
                                ) : (
                                  <div
                                    style={{ color: "#3c763d" }}
                                    dangerouslySetInnerHTML={{
                                      __html: linkReplaceFn(item.q_text_hindi),
                                    }}
                                  />
                                )}
    
                          </div>
                        </div>
                        :
                        "Data not found"
                        }
                        </>
                      );
                    })}
                  </div>
                </Tab> */}
            </Accordion.Body>
          </Accordion.Item>
        )}
        {(!isEmpty(quesHistory.subtopic) ||
          !isEmpty(quesHistory.question_type) ||
          !isEmpty(quesHistory.toughness)) && (
            <Accordion.Item eventKey="4">
              <Accordion.Header>Tagging</Accordion.Header>
              <Accordion.Body>
                <Tabs
                  defaultActiveKey="subtopic"
                  id="uncontrolled-tab-subtopic"
                  className="mb-3"
                >
                  <Tab eventKey="subtopic" title="SubTopic">
                    <div className="container-fluid">
                      {quesHistory.subtopic.map((item, i) => {
                        return (
                          <>
                            {!isEmpty(item.sub_topic_name) ? (
                              <div
                                className={`row align-items-center  ${classes.history}`}
                                key={item.id}
                              >
                                <div className="col-lg-4">
                                  <p>
                                    {moment(item.updated_on).format(
                                      "MM/DD/YYYY h:mm:ss"
                                    )}
                                  </p>
                                  <p className={classes.updatedby}>
                                    {item.audit_comment} BY: {item.name}
                                  </p>
                                </div>
                                <div className="col-lg-8">
                                  <div>
                                    {i === 0 ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "red" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(
                                            quesHistory.subtopic[i - 1]
                                              .sub_topic_name
                                          ),
                                        }}
                                      />
                                    )}
                                  </div>
                                  <p>
                                    <small>To</small>
                                  </p>
                                  {i === quesHistory.subtopic.length ? (
                                    isEmpty(item.sub_topic_name) ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "#3c763d" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(
                                            item.sub_topic_name
                                          ),
                                        }}
                                      />
                                    )
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(
                                          item.sub_topic_name
                                        ),
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ) : (
                              "Data not found"
                            )}
                          </>
                        );
                      })}
                    </div>
                  </Tab>
                  <Tab eventKey="type" title="Type">
                    <div className="container-fluid">
                      {quesHistory.question_type.map((item, i) => {
                        return (
                          <>
                            {!isEmpty(item.type) ? (
                              <div
                                className={`row align-items-center  ${classes.history}`}
                                key={item.id}
                              >
                                <div className="col-lg-4">
                                  <p>
                                    {moment(item.updated_on).format(
                                      "MM/DD/YYYY h:mm:ss"
                                    )}
                                  </p>
                                  <p className={classes.updatedby}>
                                    {item.audit_comment} BY: {item.name}
                                  </p>
                                </div>
                                <div className="col-lg-8">
                                  <div>
                                    {i === 0 ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "red" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(
                                            quesHistory.question_type[i - 1].type
                                          ),
                                        }}
                                      />
                                    )}
                                  </div>
                                  <p>
                                    <small>To</small>
                                  </p>
                                  {i === quesHistory.question_type.length ? (
                                    isEmpty(item.type) ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "#3c763d" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(item.type),
                                        }}
                                      />
                                    )
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.type),
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ) : (
                              "Data not found"
                            )}
                          </>
                        );
                      })}
                    </div>
                  </Tab>
                  <Tab eventKey="toughness" title="Toughness">
                    <div className="container-fluid">
                      {quesHistory.toughness.map((item, i) => {
                        return (
                          <>
                            {!isEmpty(item.toughness) ? (
                              <div
                                className={`row align-items-center  ${classes.history}`}
                                key={item.id}
                              >
                                <div className="col-lg-4">
                                  <p>
                                    {moment(item.updated_on).format(
                                      "MM/DD/YYYY h:mm:ss"
                                    )}
                                  </p>
                                  <p className={classes.updatedby}>
                                    {item.audit_comment} BY: {item.name}
                                  </p>
                                </div>
                                <div className="col-lg-8">
                                  <div>
                                    {i === 0 ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "red" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(
                                            quesHistory.toughness[i - 1].toughness
                                          ),
                                        }}
                                      />
                                    )}
                                  </div>
                                  <p>
                                    <small>To</small>
                                  </p>
                                  {i === quesHistory.toughness.length ? (
                                    isEmpty(item.toughness) ? (
                                      <b>Blank</b>
                                    ) : (
                                      <div
                                        style={{ color: "#3c763d" }}
                                        dangerouslySetInnerHTML={{
                                          __html: linkReplaceFn(item.toughness),
                                        }}
                                      />
                                    )
                                  ) : (
                                    <div
                                      style={{ color: "#3c763d" }}
                                      dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(item.toughness),
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ) : (
                              "Data not found"
                            )}
                          </>
                        );
                      })}
                    </div>
                  </Tab>
                </Tabs>
              </Accordion.Body>
            </Accordion.Item>
          )}
        {!isEmpty(quesHistory.block) && (
          <Accordion.Item eventKey="5">
            <Accordion.Header>Block</Accordion.Header>
            <Accordion.Body>
              <div className="container-fluid">
                {quesHistory.block.map((item, i) => {
                  return (
                    <>
                      {!isEmpty(item.block_name) ? (
                        <div
                          className={`row align-items-center  ${classes.history}`}
                          key={item.id}
                        >
                          <div className="col-lg-4">
                            <p>
                              {moment(item.updated_on).format(
                                "MM/DD/YYYY h:mm:ss"
                              )}
                            </p>
                            <p className={classes.updatedby}>
                              {item.audit_comment} BY: {item.name}
                            </p>
                          </div>
                          <div className="col-lg-8">
                            <div>
                              {i === 0 ? (
                                <b>Blank</b>
                              ) : (
                                <div
                                  style={{ color: "red" }}
                                  dangerouslySetInnerHTML={{
                                    __html: linkReplaceFn(
                                      quesHistory.block[i - 1].block_name
                                    ),
                                  }}
                                />
                              )}
                            </div>
                            <p>
                              <small>To</small>
                            </p>
                            {i === quesHistory.block.length ? (
                              isEmpty(item.block_name) ? (
                                <b>Blank</b>
                              ) : (
                                <div
                                  style={{ color: "#3c763d" }}
                                  dangerouslySetInnerHTML={{
                                    __html: linkReplaceFn(item.block_name),
                                  }}
                                />
                              )
                            ) : (
                              <div
                                style={{ color: "#3c763d" }}
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(item.block_name),
                                }}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        "Data not found"
                      )}
                    </>
                  );
                })}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
    );
  };

  const yearList = function (startYear) {
    let currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 2000;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    return years;
  };

  const onMultiSelectYear = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        exam_year: selectedList,
      };
    });
  };

  const onMultiRemoveYear = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        exam_year: selectedList,
      };
    });
  };

  const onMultiSelectName = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        exam_name: selectedList,
      };
    });
  };

  const onMultiRemoveName = (selectedList) => {
    setState((prev) => {
      return {
        ...prev,
        exam_name: selectedList,
      };
    });
  };

  const saveExamData = () => {
    const exam_year = state.exam_year;
    if (exam_year.includes("others")) {
      exam_year.splice(exam_year.indexOf("others"), 1);
    }
    const body = {
      qid: qid,
      Ename: state.exam_name.toString(),
      Eyear: exam_year.toString(),
      otherYear: state.other_year,
      inserted_by: user_id,
    };
    userService
      .saveExamDate(body)
      .then((res) => {
        console.log(res);
        toast.success("Response saved successfully.");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!!");
      });
  };

  const selectParagraph = (data) => {
    overviewInputHandler({
      paragraph_id: data.paragraph_id,
      p_text: data.p_text,
      p_text_hindi: data.p_text_hindi,
      pageNo: 0,
      m_p_text: "",
      m_p_text_hindi: "",
      matrix_paragraph_id: null,
    });
    setShowModal(false);
  };
  const selectMatrixParagraph = (data) => {
    overviewInputHandler({
      paragraph_id: null,
      p_text: "",
      p_text_hindi: "",
      pageNo: 0,
      m_p_text: data.m_p_text,
      m_p_text_hindi: data.m_p_text_hindi,
      matrix_paragraph_id: data.matrix_paragraph_id,
    });
    setShowModal(false);
  };
  const qidSubmit = (e) => {
    e.preventDefault();

    const targetQid = e.target[0].value;

    getOverviewData(targetQid);
    getHistoryData(targetQid);
  };

  return (
    <div className="section">
      <Modals
        show={blockModal}
        onHide={() => setBlockModal(false)}
      >
        <h4 className="mb-3">Block Question Reason</h4>
        <Select className='mb-3' value={blockData.block_reason} onChange={e => setBlockData(prev => { return { ...prev, block_reason: e.target.value } })}>
          <option value="" disabled>Please select reason</option>
          <option value={15}>Incorrect Tagging</option>
          <option value={19}>Question or Solution Incorrect</option>
          <option value={20}>Duplicate Question</option>
          <option value={14}>Other</option>
        </Select>
        {blockData.block_reason == 14 &&
          <Input className='mb-3' value={blockData.other_reason} onChange={e => setBlockData(prev => { return { ...prev, other_reason: e.target.value } })} placeholder='Other reason' />
        }
        <SecBTN className='sec-btn1' onClick={() => blockQuestion(1)}>Block Question</SecBTN>

      </Modals>
      <FullscreenModal show={showModal} onHide={() => setShowModal(false)}>
        <h2 className="mb-3">Paragraph Question</h2>
        {!isEmpty(state.paragraph_list) ? (
          <div className="h-100 d-flex flex-column justify-content-between">
            <div className="table-responsive mb-3">
              <table className="table table-bordered mt-2 mb-0">
                <tbody>
                  {isNormalParagraphType &&
                    state.paragraph_list.map((item) => {
                      return (
                        <tr key={item.paragraph_id}>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.p_text),
                              }}
                            />
                          </td>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.p_text_hindi),
                              }}
                            />
                          </td>
                          <td className="text-center">
                            <SecBTN
                              className="sec-btn1 py-1 px-3"
                              onClick={() => selectParagraph(item)}
                            >
                              <small>Select</small>
                            </SecBTN>
                          </td>
                        </tr>
                      );
                    })}
                  {isMatrixParagraphType &&
                    state.paragraph_list.map((item) => {
                      return (
                        <tr key={item.paragraph_id}>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.m_p_text),
                              }}
                            />
                          </td>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(item.m_p_text_hindi),
                              }}
                            />
                          </td>
                          <td className="text-center">
                            <SecBTN
                              className="sec-btn1 py-1 px-3"
                              onClick={() => selectMatrixParagraph(item)}
                            >
                              <small>Select</small>
                            </SecBTN>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between">
              <SecBTN
                className="sec-btn1"
                disabled={state.pageNo === 0}
                onClick={() => {
                  overviewInputHandler({ pageNo: state.pageNo - 10 });
                  getParagraphList(state.pageNo - 10);
                }}
              >
                Prev
              </SecBTN>
              <SecBTN
                className="sec-btn1"
                disabled={state.paragraph_list.length < 4}
                onClick={() => {
                  overviewInputHandler({ pageNo: state.pageNo + 10 });
                  getParagraphList(state.pageNo + 10);
                }}
              >
                Next
              </SecBTN>
            </div>
          </div>
        ) : (
          "No paragraphes available for this QID."
        )}
      </FullscreenModal>
      {isLoading && <Loader />}
      <Toast />
      <div className="d-flex justify-content-between align-items-center h-100">
        <div>
          <h4>Edit Question</h4>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/editQuestion">Question</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/editQuestion">Edit Question</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Edit</Breadcrumb.Item>
            <Breadcrumb.Item active>{navBtnActive}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>
          <NavLink to="/editQuestion/addQuestion">
            <SecBTN className={`sec-btn ${classes.btn}`}>Add New Question</SecBTN>
          </NavLink>

        </div>
      </div>
      <Graybg>
        <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
          <div className="d-flex align-items-center gap-2">
            <h6>
              QID: <b style={{
                color: state.is_JeeSheet === 1 && state.is_NeetSheet === 1 ? "#b212b5" :
                  state.is_JeeSheet === 1 ? "#0619ff" :
                    state.is_NeetSheet === 1 ? "#3a8d07" :
                      state.is_PYQSheet === 1 ? "#a50707" :
                        "#212529" // Default text color if no condition matches
              }}>{qid}</b>
            </h6>

            {/* JEE Sheet Badge */}
            {state.is_JeeSheet === 1 && state.is_NeetSheet === 0 && (
              <span className="badge" style={{ background: "#0619ff" }} title="JEE Sheet Question">
                JS
              </span>
            )}

            {/* NEET Sheet Badge */}
            {state.is_NeetSheet === 1 && state.is_JeeSheet === 0 && (
              <span className="badge" style={{ background: "#3a8d07" }} title="NEET Sheet Question">
                NS
              </span>
            )}

            {/* JEE & NEET Sheet Badge */}
            {state.is_JeeSheet === 1 && state.is_NeetSheet === 1 && (
              <span className="badge" style={{ background: "#b212b5" }} title="JEE & NEET Sheet Question">
                JS&NS
              </span>
            )}

            {/* PYQ Sheet Badge */}
            {state.is_PYQSheet === 1 && (
              <span className="badge" style={{ background: "#a50707" }} title="PYQ Sheet Question">
                PYQ
              </span>
            )}
          </div>

          <div className='d-flex justify-content-between'>

            <form className="d-flex justify-content-between align-items-center gap-2" onSubmit={qidSubmit}>
              <Input
                style={{ background: "#fff" }}
                type="number"
                placeholder="Search QID"
                name="qid"
              />
              <SecBTN type="submit" className="sec-btn1" style={{ padding: "0.2rem 0.5rem", marginRight: '1rem' }}>
                Search
              </SecBTN>
            </form>
            <NavLink to="#">
              <SecBTN className={`sec-btn ${classes.blockbtn}`} onClick={handleTranslate}>All Translate</SecBTN>
            </NavLink>
            <NavLink to="#">
              <SecBTN className={`sec-btn ${classes.blockbtn}`} onClick={handleSolutionTranslate}>Solution Translate</SecBTN>
            </NavLink>
            <NavLink to="#">
              <SecBTN className={`sec-btn ${classes.blockbtn}`} onClick={handleGenerateSolution}>Generate Solution</SecBTN>
            </NavLink>

          </div >
          <SecBTN
            className={classes.blockbtn}
            onClick={state.block_lvl == 0 ? () => setBlockModal(true) : () => blockQuestion(0)}
          >
            {state.block_lvl == 0 ? "Block" : "Unblock"} Question
          </SecBTN>
        </div>
        <div className={`mb-4 ${classes.navPanel}`}>
          {navBtn.map((navItem) => {
            return (
              <button
                key={navItem}
                className={
                  navItem === navBtnActive
                    ? classes.navItemActive
                    : classes.navItem
                }
                onClick={() => setNavBtnActive(navItem)}
              >
                {navItem}
              </button>
            );
          })}
        </div>
        {/* {renderSection(navBtnActive)} */}
        {navBtnActive === navBtn[0] && renderOverview()}
        {navBtnActive === navBtn[1] && <Question />}
        {/* Option section rendered according to answer type */}
        {navBtnActive === navBtn[2] && (single_correct || multi_correct) && (
          <>
            <Row>
              <Col lg={6} md={12} sm={12} className="my-2">
                {state.eng_option.map((options, i) => {
                  return (
                    <div key={options.client_key} className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <Form.Check
                          inline
                          checked={options.is_correct == 1}
                          value={options.option_id}
                          label={`Option ${i + 1}`}
                          name="eng_option"
                          type={single_correct ? "radio" : "checkbox"}
                          onChange={(e) => optionRadioHandler(e, i)}
                        />
                        <span
                          className={classes.cross}
                          onClick={() => removeOption(i)}
                        >
                          x
                        </span>
                      </div>
                      <MyEditor
                        enablePixelImageSize
                        className="options-editor"
                        data={options.option}
                        handleChange={(data) => {
                          setState((prev) => ({
                            ...prev,
                            eng_option: prev.eng_option.map((option, index) =>
                              index === i
                                ? {
                                  ...option,
                                  option: data,
                                }
                                : option
                            ),
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </Col>
              <Col lg={6} md={12} sm={12} className="my-2">
                {state.h_option.map((options, i) => {
                  return (
                    <div key={options.client_key} className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <Form.Check
                          inline
                          checked={options.is_correct == 1}
                          value={options.option_id}
                          label={`Option ${i + 1}`}
                          name="hindi_option"
                          type={single_correct ? "radio" : "checkbox"}
                          onChange={(e) => optionRadioHandler(e, i)}
                        />
                        <span
                          className={classes.cross}
                          onClick={() => removeOption(i)}
                        >
                          x
                        </span>
                      </div>
                      <MyEditor
                        enablePixelImageSize
                        className="options-editor"
                        data={options.option}
                        handleChange={(data) => {
                          setState((prev) => ({
                            ...prev,
                            h_option: prev.h_option.map((option, index) =>
                              index === i
                                ? {
                                  ...option,
                                  option: data,
                                }
                                : option
                            ),
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </Col>
            </Row>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                <SecBTN className="sec-btn" onClick={addNewOption}>
                  Add Option
                </SecBTN>
                <SecBTN className="sec-btn1 ms-2" onClick={saveOptions}>
                  Save Options
                </SecBTN>
              </div>
              <div>
                <SecBTN className="sec-btn" onClick={() => {
                  setState(prev => ({ ...prev, eng_option: [] }));
                }}>
                  Delete All English Options
                </SecBTN>
                <SecBTN className="sec-btn ms-2" onClick={() => {
                  setState(prev => ({ ...prev, h_option: [] }));
                }}>
                  Delete All Hindi Options
                </SecBTN>
                <SecBTN className="sec-btn ms-2" onClick={() => {
                  setState((prev) => {
                    const copiedHindiOptions = prev.eng_option
                      .slice(0, MAX_OPTIONS)
                      .map((option, index) => {
                        const hindiOptionId =
                          originalOptionIdsRef.current[2][index] ?? "";

                        return {
                          ...option,
                          option_id: hindiOptionId,
                          client_key: createOptionClientKey(
                            2,
                            hindiOptionId
                          ),
                          lang_id: 2,
                        };
                      });

                    return {
                      ...prev,
                      h_option: copiedHindiOptions,
                    };
                  });
                }}>
                  Copy English Options
                </SecBTN>
              </div>
            </div>
          </>
        )}
        {navBtnActive === navBtn[2] && (integer_correct || subjective) && (
          <>
            <Input
              placeholder="Enter answer here..."
              name="option"
              type="number"
              className="mb-3"
              value={state.answer}
              onChange={(e) => {
                overviewInputHandler({ answer: e.target.value });
              }}
            />
            <SecBTN className="sec-btn1" onClick={saveOptionsInput}>
              Save Answer
            </SecBTN>
          </>
        )}
        {navBtnActive === navBtn[3] && <Hints />}
        {navBtnActive === navBtn[4] && <Solution />}
        {navBtnActive === navBtn[5] && <History />}
        {navBtnActive === navBtn[6] && (
          <>
            <div style={{ margin: "20px 0 10px" }}>
              <MultiSelectDropdown
                isObject={false}
                options={[...yearList(2001), "others"]}
                selectedValues={state.exam_year}
                onSelect={onMultiSelectYear}
                onRemove={onMultiRemoveYear}
                placeholder="Exam Year"
              />
            </div>
            <div style={{ margin: "10px 0 10px" }}>
              {state.exam_year.includes("others") && (
                <Input
                  placeholder="Other year"
                  type="tel"
                  maxlength="4"
                  pattern="[0-9]{4}"
                  onChange={(e) => {
                    console.log(e.target.value.length);
                    overviewInputHandler({ other_year: e.target.value });
                  }}
                />
              )}
            </div>
            <div style={{ margin: "10px 0 20px" }}>
              <MultiSelectDropdown
                isObject={false}
                options={
                  state.sub_id == 3
                    ? ["JEE Advanced", "JEE-Main"]
                    : state.sub_id == 4
                      ? ["NEET"]
                      : ["JEE Advanced", "JEE-Main", "NEET", "MHT-CET"]
                }
                selectedValues={state.exam_name}
                onSelect={onMultiSelectName}
                onRemove={onMultiRemoveName}
                placeholder="Exam Name"
              />
            </div>
            <SecBTN className="sec-btn1" onClick={saveExamData}>
              Save
            </SecBTN>
          </>
        )}
      </Graybg>
    </div>
  );
};

export default Edit;
